import { useRepository } from "./use-repository.js";
export const fakeClick = obj => {
  const ev = document.createEvent('MouseEvents');
  ev.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  obj.dispatchEvent(ev);
};
export const downloadFile = (name, repositoryUrl) => {
  const saveLink = document.createElement('a');
  saveLink.href = `${repositoryUrl}${name}?download?t=${Date.now()}`;
  saveLink.target = '_blank';
  fakeClick(saveLink);
};

/**
 * Custom hook that downloads a specified content from a repository
 * Has to be wrapped with **RepositoryContext**
 */
export const useDownload = content => {
  const repo = useRepository();
  const isFile = repo.schemas.isContentFromType(content, 'File');
  return {
    /**
     * Boolean that indicates if the content is a File
     */
    isFile,
    /**
     * Callback that will trigger the download
     */
    download: () => downloadFile(content.Path, repo.configuration.repositoryUrl)
  };
};
//# sourceMappingURL=use-download.js.map